import config from "../utils/config.json";
import i18next from "i18next";

const countries = [
  {
    label: "Costa Rica",
    value: "CR",
  },
  {
    label: "Panamá",
    value: "PA",
  },
];

const getCurrencies = (country) => {
  return config[country].currency.map(({ name: label, value }) => ({
    value,
    label,
  }));
};

const getFilters = (options = []) =>
  options.map(({ name, ...rest }) => ({
    name: i18next.t(`general.filters.${name}`),
    ...rest,
  }));

const getBillStatusKey = (status, userType) => {
  let statusCode = [];
  switch (status) {
    case "ACCEPTED":
      statusCode.push(getBillStatusKeyByUser(userType));
      break;
    case "CANCELLED":
      statusCode.push(getBillStatusKeyByUser(userType));
      break;
    default:
      statusCode.push("");
      break;
  }
  statusCode.push(status);
  return statusCode.join("");
};

const getBillStatusKeyByUser = (userType) => {
  const CLIENT = "CLIENT_";
  const PROVIDER = "PROVIDER_";

  switch (userType) {
    case "CSA":
      return CLIENT;
    case "PRO":
      return PROVIDER;
    default:
      return "";
  }
};

export const convertTimeToMilliseconds = (hours, minutes, seconds, milliseconds) =>
  hours * 3600000 + minutes * 60000 + seconds * 1000 + milliseconds;

const handleWorkingHours = (countryCode) => {
  const actualDate = new Date();
  const startTimeHours = countryCode === "PA" ? 8 : 7;
  const startTimeMinutes = 0;
  const startTimeSeconds = 0;
  const startTimeMilliseconds = 0;
  const endTimeHours = countryCode === "PA" ? 17 : 16;
  const endTimeMinutes = 0;
  const endTimeSeconds = 0;
  const endTimeMilliseconds = 0;

  const timeZone =
    countryCode === "PA" ? "America/Panama" : "America/Costa_Rica";
  const dayOfWeek = actualDate.toLocaleDateString("en-US", {
    timeZone,
    weekday: "long",
  });

  if (dayOfWeek === "Saturday" || dayOfWeek === "Sunday") {
    return false;
  }

  const dateFormatter = Intl.DateTimeFormat("en-US", {
    timeZone,
    hour12: false,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 3,
  });

  const parts = dateFormatter.formatToParts(actualDate);

  const currentHours = parseInt(
    parts.find((part) => part.type === "hour").value
  );
  const currentMinutes = parseInt(
    parts.find((part) => part.type === "minute").value
  );
  const currentSeconds = parseInt(
    parts.find((part) => part.type === "second").value
  );
  const currentMilliseconds = parseInt(
    parts.find((part) => part.type === "fractionalSecond").value
  );

  const currentTimeInMilliseconds = convertTimeToMilliseconds(
    currentHours,
    currentMinutes,
    currentSeconds,
    currentMilliseconds
  );

  const startTimeInMilliseconds = convertTimeToMilliseconds(
    startTimeHours,
    startTimeMinutes,
    startTimeSeconds,
    startTimeMilliseconds
  );

  const endTimeInMilliseconds = convertTimeToMilliseconds(
    endTimeHours,
    endTimeMinutes,
    endTimeSeconds,
    endTimeMilliseconds
  );

  return (
    currentTimeInMilliseconds >= startTimeInMilliseconds &&
    currentTimeInMilliseconds <= endTimeInMilliseconds
  );
};
export {
  countries,
  getCurrencies,
  getFilters,
  getBillStatusKey,
  handleWorkingHours,
};
